import * as SystemActions from './../../system/actions/system.actions';
import { IRegistrationKiwiSaverStatusState, initialRegistrationKiwiSaverStatusState } from './../../state/registration-kiwisaver.state';
import * as RegistrationKiwiSaverActions from '../actions/registration-kiwisaver.actions';

export function RegistrationKiwiSaverStatusReducer(state = initialRegistrationKiwiSaverStatusState, action: RegistrationKiwiSaverActions.RegistrationKiwiSaverActions | SystemActions.SystemActions): IRegistrationKiwiSaverStatusState {
    switch (action.type) {
        case RegistrationKiwiSaverActions.REGISTER_KIWISAVER: {
            return initialRegistrationKiwiSaverStatusState;
        }
        case RegistrationKiwiSaverActions.REGISTER_KIWISAVER_FAIL: {
            return {
                ...state,
                failText: action.payload
            };
        }
        case RegistrationKiwiSaverActions.REGISTER_KIWISAVER_GET_STATUS_FAIL: {
            return {
                ...state,
                failText: action.payload
            };
        }
        case RegistrationKiwiSaverActions.REGISTER_KIWISAVER_UPDATE_ENTITY: {
            return {
                ...state,
                status: action.payload.Status
            };
        }
        case SystemActions.CLEAR_SYSTEM:
        case RegistrationKiwiSaverActions.REGISTER_KIWISAVER_GET_STATUS:
            return initialRegistrationKiwiSaverStatusState;
        default: {
            return state;
        }
    }
}
